"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  noCamelize: true,
  slugify: true
};
exports.slugify = exports.noCamelize = void 0;

var _actions = require("./actions");

Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _actions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});

var _sortHelpers = require("./sortHelpers");

Object.keys(_sortHelpers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _sortHelpers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sortHelpers[key];
    }
  });
});

var _maxValueHelpers = require("./maxValueHelpers");

Object.keys(_maxValueHelpers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _maxValueHelpers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _maxValueHelpers[key];
    }
  });
});

var _numberFormatting = require("./numberFormatting");

Object.keys(_numberFormatting).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _numberFormatting[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _numberFormatting[key];
    }
  });
});

var _communityHelpers = require("./communityHelpers");

Object.keys(_communityHelpers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _communityHelpers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _communityHelpers[key];
    }
  });
});

var _selectCommunityDescriptionHelper = require("./selectCommunityDescriptionHelper");

Object.keys(_selectCommunityDescriptionHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _selectCommunityDescriptionHelper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selectCommunityDescriptionHelper[key];
    }
  });
});

var _liveCMSEndpointHelpers = require("./liveCMSEndpointHelpers");

Object.keys(_liveCMSEndpointHelpers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _liveCMSEndpointHelpers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _liveCMSEndpointHelpers[key];
    }
  });
});

var _productEndpointHelper = require("./productEndpointHelper");

Object.keys(_productEndpointHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _productEndpointHelper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _productEndpointHelper[key];
    }
  });
});

var _localStorageHook = require("./localStorageHook");

Object.keys(_localStorageHook).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _localStorageHook[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _localStorageHook[key];
    }
  });
});

var _pdf = require("./pdf");

Object.keys(_pdf).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _pdf[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pdf[key];
    }
  });
});

var _personas = require("./personas");

Object.keys(_personas).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _personas[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _personas[key];
    }
  });
});

var noCamelize = function noCamelize(key, convert) {
  if (key.toLowerCase() === 'id') {
    return 'id';
  }

  return /(^[A-Z0-9_]+$|^id+$)/.test(key) ? key : convert(key);
};

exports.noCamelize = noCamelize;

var slugify = function slugify(text) {
  return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
};

exports.slugify = slugify;